module.exports = __webpack_public_path__ + "static/media/gpv-private-billed-medical-centre.3f998dcd.png";